// extracted by mini-css-extract-plugin
export var marginNegative = "_59-5 _59-3 _59-1";
export var marginPositive = "_59-4 _59-3 _59-1";
export var modalContent = "_59-6";
export var samplesTable = "_59-8";
export var samplesTableContainer = "_59-7";
export var statBox = "_59-a";
export var tableCell = "_59-1";
export var tableCellCenter = "_59-2 _59-1";
export var tableCellRight = "_59-3 _59-1";
export var tableHeader = "_59-0";
export var trackingNumber = "_59-9";